(() => {
  const measured = new WeakSet();
  function measureHeader() {
    const announcement = document.querySelector('#header-group .announcement');
    if (!announcement || measured.has(announcement)) return;
    measured.add(announcement);
    const update = () => document.documentElement.style.setProperty('--hw-announcement-height', `${announcement.getBoundingClientRect().height}px`);
    new ResizeObserver(update).observe(announcement);
    update();
  }
  measureHeader();
  document.addEventListener('shopify:section:load', measureHeader);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const toggle = event.target.closest('[data-hw-menu]');
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!nav) return;
      nav.hidden = !nav.hidden;
      toggle.setAttribute('aria-expanded', String(!nav.hidden));
      return;
    }
    const opener = event.target.closest('[data-hw-dialog]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.hwDialog);
      if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-hw-close]');
    if (close) close.closest('dialog')?.close();
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('hw-flavor-dialog')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    if (event.target.closest('#mobile-nav a')) {
      document.getElementById('mobile-nav').hidden = true;
      document.querySelector('[data-hw-menu]')?.setAttribute('aria-expanded', 'false');
    }
  });
  document.addEventListener('keydown', event => {
    const toggle = document.querySelector('[data-hw-menu][aria-expanded="true"]');
    if (event.key === 'Escape' && toggle && !document.querySelector('dialog[open]')) {
      document.getElementById(toggle.getAttribute('aria-controls')).hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
  });
})();

// Preserve old homepage fragment links printed or shared before the move.
(() => {
 const destinations={lineup:'card',drops:'pickup',judges:'inside',joinbox:'signup',top:'MainContent'};
 const follow=()=>{const target=destinations[location.hash.slice(1)];if(target)document.getElementById(target)?.scrollIntoView();};
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',follow,{once:true});else follow();
 window.addEventListener('hashchange',follow);
})();
